import i18n from "i18next";
import i18nLangDet from "i18next-browser-languagedetector";
import $i18n from "jquery-i18next";
import resources from '../locales';

const $ = require('jquery');
const Handlebars = require('handlebars');
const _ = require('underscore');
const moment = require('moment');
require('./handlebars-helpers');
require('libs/bootstrap-3.3.2-dist/js/bootstrap.min');
require('jquery-ui');
require('jqueryEditable');
require('jqueryDatetimepicker');
require('jquery-datetimepicker/jquery.datetimepicker.css');
require('libs/jquery-editable/modules/datepicker.editable');
require('libs/jquery-metroUi/js/metro-notify');
require('dhtmlxMessage');
require('metroHelpers');


$(function () {
    i18n.truncLang = function () {
        const i = i18n.language.indexOf("-");
        if (i === -1) {
            return i18n.language;
        }
        else {
            return i18n.language.substring(0, i);
        }
    };

    i18n.use(i18nLangDet)
        .init({
            fallbackLng: 'el',
            initImmediate: false,
            resources,
            whitelist: ['en', 'el'],
            detection: {
                order: ['localStorage', 'querystring', 'cookie', 'navigator', 'htmlTag']
            }
        }, main.bind(this));

});

var initialProfileObject = {};

function wireForgetMeCheckbox() {
    $('#forgetMe').click(() => {
        dhtmlx.confirm({
            type: 'confirm',
            text: i18n.t('forgetMeText'),
            ok: i18n.t('yes'),
            cancel: i18n.t('no'),
            callback: result => {
                if (result) {
                    forgetMe.call(this);
                }
            }
        });
    });
}

function wireUpdateButton() {
    $('#update').click(() => {
        updateFields();
    });
}

function wireOptoutCheckbox() {
    $('#optout').click(() => {
        dhtmlx.confirm({
            type: 'confirm',
            text: i18n.t('optoutText'),
            ok: i18n.t('yes'),
            cancel: i18n.t('no'),
            callback: result => {
                if (result) {
                    optout.call(this);
                }
            }
        });
    });
}

async function forgetMe() {
    try {
        const result = await $.ajax({
            type: 'post',
            url: `/CampaignCloud/Profile/${this.hash}/forgetMe`,
            dataType: 'json'
        });
        if (result.outcome === "Error") {
            $.Notify.error(i18n.t("somethingWentWrong"));
        } else {
            $.Notify.show(i18n.t("forgotten"));
        }
    } catch (error) {
        console.error(error);
    }
}

async function optout() {
    try {
        const result = await $.ajax({
            type: 'post',
            url: `/CampaignCloud/Profile/${this.hash}/optout`,
            dataType: 'json'
        });
        if (result.outcome === "Error") {
            $.Notify.error(i18n.t("somethingWentWrong"));
        } else {
            $.Notify.show(i18n.t("optedOut"));
        }
    } catch (error) {
        console.error(error);
    }
}

async function main(t) {

    const templates = {
        contactIcon: Handlebars.compile(require('./templates/contactIcon.partial.template.htm')),
        subscriberName: Handlebars.compile(require('./templates/subscriberName.partial.template.htm')),
        updateProfile: Handlebars.compile(require('./templates/updateProfile.partial.template.htm')),
        updateVoucher: Handlebars.compile(require('./templates/updateVoucherLink.partial.template.htm')),
        pointsBalance: Handlebars.compile(require('./templates/pointsBalance.partial.template.htm')),
        info: Handlebars.compile(require('./templates/info.partial.template.htm')),
        voucherLinks: Handlebars.compile(require('./templates/voucherLink.partial.template.htm'))
    };

    this.hash = window.location.href.split('#')[1];
    this.accountId = window.location.hostname.split('.')[0];

    try {
        const data = await $.ajax({
            type: "GET",
            url: `/CampaignCloud/Profile/${this.hash}`,
            dataType: "json"
        });


        const voucherLinkData = await $.ajax({
            type: "GET",
            url: `/CampaignCloud/Profile/getVoucherLinksBySubscription/${data.subscriptionId}`,
            dataType: "json"
        });

        if (voucherLinkData.length !== 0)
            _.each(voucherLinkData, voucherLink => {
                voucherLink.accountId = this.accountId;
                $('#voucherLink').append(templates.voucherLinks(voucherLink));
            })
        else {
            $('#voucherLink').addClass('inputform2').text(i18n.t("noActiveVoucher"))
        }

        $('#subscriberPhotoBox').html(templates.contactIcon(data));
        $('#subscriberName').html(templates.subscriberName(data));
        $('#updateProfile').html(templates.updateProfile(data));
        $('#updateVoucher').html(templates.updateVoucher(data));
        $('#info').html(templates.info(data));
        $('#pointsBalance').html(templates.pointsBalance(data));

        wireForgetMeCheckbox.call(this);
        wireOptoutCheckbox.call(this);
        wireUpdateButton();

        $(".profileField").off("change").on("change", (event) => { inputChange($(event.currentTarget)); } );
        $(".profileField").off("focusin").on("focusin", (event) => { inputFocus($(event.currentTarget)); } );
        $(".profileField").off("blur").on("blur", (event) => { inputBlur($(event.currentTarget)); } );

        initDatetimePicker($('#birthday'));

        initialProfileObject = data;
    } catch (error) {
        console.error(error);
    }

}

function initDatetimePicker(e) {
    const minDate = $(e).data('mindate');
    const maxDate = $(e).data('maxdate');
    $(e).datetimepicker({
        lang: i18n.truncLang(),
        timepicker: false,
        minDate: minDate !== undefined ? minDate : false,
        maxDate: maxDate !== undefined ? maxDate : false
    });
}

function inputChange(input) {
    var format = 'YYYY-MM-DD';
    if(input.hasClass('datepicker')) {
        if(input.val() == "")
            return; //nullification of field

        const m = moment();
        const ld = m.localeData();
        const df = format;
        const d = moment(input.val(), df);
        input.val(d.format('YYYY-MM-DD'));
    }
    validateValue(input);
}
function inputFocus(input) {
    input.parent().parent().find('.error-message').empty();
    return true;
}
function inputBlur(input) {
    validateValue(input);
    return true;
}

function validateMaxLength(input, maxLength) {
    if(input.val().length <= maxLength) {
        input.parent().parent().find(".error-message").hide();
        input.parent().parent().find(".error-message").empty();
        return true;
    }

    input.parent().parent().find('.error-message').text(i18n.t("invalidLength", {countLength: maxLength}));
    input.parent().parent().find('.error-message').show();
    return false;
}
function validateMinLength(input, minLength) {
    if(input.val().length >= 0 && input.val().length >= minLength) {
        input.parent().parent().find(".error-message").hide();
        input.parent().parent().find(".error-message").empty();
        return true;
    }

    input.parent().parent().find('.error-message').text(i18n.t("invalidMinLength", {countLength: minLength}));
    input.parent().parent().find('.error-message').show();
    return false;
}
function validateValue(input) {
    if(input.hasClass("datepicker"))
        return validateBirthDate(input);
    else {
        var maxLength = input.prop("maxlength");
        var minLength = input.prop("minlength");

        var flag = true;
        if(maxLength)
            flag = flag && validateMaxLength(input, maxLength);
        if(minLength)
            flag = flag && validateMinLength(input, minLength);

        return flag;
    }

}

function validateBirthDate(input) {
    var inputDate = new Date(input.val());
    if (new Date().getFullYear() < inputDate.getFullYear()) {
        $.Notify.error(i18n.t("birthdayNotAfterNow"));
        input.parent().parent().find('.error-message').text(i18n.t("birthdayNotAfterNow"));
        input.parent().parent().find('.error-message').show();
        return false;
    }
    return true;
}

async function updateFields() {
    $("#responseMessage").find(".visible").removeClass("visible");

    var shouldUpdate = true;
    var fields = $(".profileField");
    var toUpdate = {};
    fields.each(function(elem, index) {
        if($(this).data("initial-value") != $(this).val() && $(this).val() != initialProfileObject[$(this).data("field")]) {
            if(validateValue($(this)))
                toUpdate[$(this).data("field")] = $(this).val();
            else
                shouldUpdate = false;
        }
    });

    if(!shouldUpdate)
        return;

    var tempObject = {};
    $.extend(tempObject, toUpdate);

    //need for backend
    if(toUpdate['dateOfBirth'] != null && toUpdate['dateOfBirth'] != "") {
        toUpdate['dateOfBirth'] = "date:" + toUpdate['dateOfBirth']
    }else {
        delete toUpdate['dateOfBirth'];
    }

    if(!$.isEmptyObject(toUpdate)) {
        var hash = window.location.href.split('#')[1];
        const response = await $.ajax({
            url: `/CampaignCloud/Profile/update/${hash}`,
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(toUpdate),
            dataType: 'json'
        });
        if(response.outcome == "OK") {
            toUpdate = tempObject; //set the normalized values (without the `date:` in the dateOfBirthField

            $.extend(initialProfileObject, toUpdate);
            console.log("STATUS OK");
            for (var key in toUpdate)
                $('[data-field="'+ key +'"]').data("initial-value", toUpdate[key]);

            $("#responseMessage").find(".updateSuccess").addClass("visible");
            $.Notify.show(i18n.t("updateSuccess"));
        }else if(response.outcome == "None") {
            console.log("STATUS None");
            $("#responseMessage").find(".noChangesDetected").addClass("visible");
            $.Notify.info(i18n.t("noChanges"));
        }else {
            console.error("STATUS Error",response);
            $("#responseMessage").find(".updateFailed").addClass("visible");
            $.Notify.error(i18n.t("updateFailed"));
        }
    }else {
        console.log("No changes detected");
        $("#responseMessage").find(".noChangesDetected").addClass("visible");
        $.Notify.error(i18n.t("noChanges"));
    }
}

// Info
$.Notify.info = function (message, title) {
    return $.Notify({
        content: message,
        style: {
            color: '#1B6EAE',
            background: '#fff'
        },
        caption: title
    });
};